/*
 * Wave path: M0 0 v100 h1440 V0 c-215.16 20.04 -460.111 31.38 -720 31.38 S215.156 20.04 0 0 Z
 *
 * Path geometry (in viewBox units):
 *   (0,0) → (0,100) → (1440,100) → (1440,0)  (rectangle for the solid lower part)
 *   then curves down to (720, 31.38) and back up to (0, 0)  (the wave dip on top)
 *
 * So the transparent area at the top reaches y = 31.38 at its deepest point (x = 720).
 *   viewBox height is 100, so the transparent strip is 31.38% of the rendered SVG height.
 *
 * Because the SVG is rendered at width: 100% with auto height, that means
 *   transparent depth (px) = renderedWidth × (31.38 / 1440)
 *   which is equivalent to (100vw * 31.38 / 1440) when the SVG spans the viewport.
 */

export const WAVE_VIEWBOX_WIDTH = 1440;
export const WAVE_VIEWBOX_HEIGHT = 100;
export const WAVE_DEEPEST_Y = 31.38;

/** Height of the transparent area at the top of the wave, as a fraction of the SVG's rendered height. */
export const WAVE_TRANSPARENT_HEIGHT_RATIO = WAVE_DEEPEST_Y / WAVE_VIEWBOX_HEIGHT; // 0.3138

/** CSS calc() expressing the wave's transparent depth in vw, assuming the wave spans full viewport width. */
export const WAVE_OVERLAP_VW = `calc(100vw * ${WAVE_DEEPEST_Y} / ${WAVE_VIEWBOX_WIDTH})`;

export const Wave = () => (
    <svg viewBox={`0 0 ${WAVE_VIEWBOX_WIDTH} ${WAVE_VIEWBOX_HEIGHT}`} xmlns="http://www.w3.org/2000/svg" className="r-block r-h-auto r-w-full">
        <g fillRule="nonzero" fill="none">
            <path d="M0 0v100h1440V0c-215.16 20.04-460.111 31.38-720 31.38S215.156 20.04 0 0Z" fill="#2c2c2b" />
        </g>
    </svg>
);
